<mat-menu #listsMenu="matMenu">
  <button mat-menu-item appStopPropagation (click)="openNewListDialog()">
    <mat-icon>add</mat-icon> {{ 'button.newList' | translate }}
  </button>
  <mat-divider *ngIf="userService.lists.length"></mat-divider>
  <button mat-menu-item *ngFor="let list of userService.lists" appStopPropagation (click)="addToList(list.id)">
    {{ list.name }}
    <span *ngIf="isRecordInList(list.id)" class="odilo-icon check" aria-hidden="true">check</span>
  </button>
</mat-menu>

<mat-menu #listsMenu2="matMenu">
  <button mat-menu-item (click)="openNewListDialog()">
    <mat-icon>add</mat-icon> {{ 'button.newList' | translate }}
  </button>
  <mat-divider *ngIf="userService.lists.length"></mat-divider>
  <button class="list-container" mat-menu-item *ngFor="let list of userService.lists" (click)="addToList(list.id)">
    <span class="list-container__list-name" ellipsis> {{list.name}} </span>
    <span *ngIf="isRecordInList(list.id)" class="odilo-icon check" aria-hidden="true">check</span>
  </button>
</mat-menu>

<button
  id="addToListButton"
  *ngIf="!isMoreOption"
  mat-flat-button
  class="only-icon"
  [opacTooltip]="'tooltip.addToList.label' | translate"
  [attr.aria-label]="'tooltip.addToList.label' | translate"
  [dir]="textDirection"
  [matMenuTriggerFor]="listsMenu">
  <span class="odilo-icon" aria-hidden="true">list_notebook</span>
</button>
<button
  *ngIf="isMoreOption"
  mat-menu-item
  class="only-icon add-to-list__item"
  [dir]="textDirection"
  [matMenuTriggerFor]="listsMenu2">
  <span class="add-to-list__item-text">
    <span class="odilo-icon" aria-hidden="true">list_notebook</span>
    {{ 'tooltip.addToList.label' | translate }}
  </span>
  <span class="odilo-icon arrow" aria-hidden="true">navigate_next</span>
</button>
